// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import { AnimatedView, StatsCard, WorkProgress } from "../../../components";
import { Redirect, Link } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { siteActions } from "../../../redux/actions/siteActions";
import isEmpty from "lodash.isempty";

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';

import DatetimeRangePicker from 'react-bootstrap-datetimerangepicker';
import ReactHtmlParser from "react-html-parser";
import moment from 'moment';
import {
  Button,
  FormControl,
  FormGroup,
} from "react-bootstrap";
import "./dashboard.css";
var BarChart = require("react-d3-components").BarChart;
var isLoading = "false";
var BarData = [];
let salesAmt="";
class Dashboard extends Component {
   _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      dashboardData: {},
      loading: false,
      startDate: moment().subtract(6, 'days'),
      lastStartDate: "",
      cityList: [],
      arrangeByCity: '',
      endDate: moment(),
      lastEndDate: "",
      arrangeBy: "days",
      ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      rangesByMonth: {
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Last 3 Months': [moment().subtract(3, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Last 6 Months': [moment().subtract(6, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Last 12 Months': [moment().subtract(12, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      currency: '',
    };

    this.handleDateEvent = this.handleDateEvent.bind(this);
  }

  handleDateEvent(event, picker) {
    event.preventDefault();
    console.log("handleDateEvent..")
    this.setState({
      startDate: picker.startDate,
      endDate: picker.endDate
    });
    
    if(this.state.lastStartDate !== picker.startDate || this.state.lastEndDate !== picker.endDate) {
      const {
        actions: { getDashobardData }
      } = this.props;

      let startDate = moment(picker.startDate).format("YYYY-MM-DD 00:00:00");
      let endDate = moment(picker.endDate).format("YYYY-MM-DD 23:59:59");
      isLoading = "true";
      getDashobardData({ graphDateRange: 'dateRange',limit:this.state.limit, startDate:startDate,  endDate:endDate, arrangeBy: this.state.arrangeBy, cityID: this.state.cityID});
    }
  }

  componentDidMount() {
    this._isMounted = true;
    const {
      actions: { getDashobardData }
    } = this.props;

    let startDate = moment(this.state.startDate).format("YYYY-MM-DD 00:00:00");
    let endDate = moment(this.state.endDate).format("YYYY-MM-DD 23:59:59");
    this.setState({
      lastStartDate: this.state.startDate,
      lastEndDate: this.state.endDate
    })
    console.log("getDashobardData...")
    isLoading = "true";
    getDashobardData({ graphDateRange: 'dateRange',limit:this.state.limit, startDate:startDate,  endDate:endDate });
    if (this.props.error) {
      this.setState({ loading: false });
    }

    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData) {
      if(siteData.currency) {
        let symbol = '$'; //(siteData.currency == 'USD') ? '$' : 'C$'; //Changed on client dimand by Visham
        localStorage.setItem("symbol", symbol);
        this.setState({currency: siteData.currency, symbol: '$'}) //(siteData.currency == 'USD') ? '$' : 'C$' in place of '$'
      }
    }
    if (siteData.active_cities) {
      this.setState({
        cityList: siteData.active_cities,
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dashboardData) {
      isLoading = "false"; 
      this.setState({ 
        dashboardData: nextProps.dashboardData, 
        lastStartDate: this.state.startDate,
        lastEndDate: this.state.endDate
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  tooltipBar(x, y, y0) {
    return (y==0) ? (" Transactions : " + y0) :  (" Sales : " + y0); 
  };

  toDollars=( nValue, nWide )=> {
    var s= nValue.toFixed(2);
    let j;
    for( j=6; j<15; j+=4 ) {  // insert commas
        if ( s.length > j ) { 
            s= s.substr(0,s.length-j)+','+ s.substr(s.length-j);
        }
    }
    s= this.state.symbol+''+s;  // leading dollar sign
    if ( !isNaN(nWide) ) { // parameter is present
        while( nWide > s.length ) {  // pad with leading spaces
            s=' '+s;
        }
    }
    return(s);
  }

  onUpdateView = () => evt => {
    let startDate, endDate;
    if(evt.target.value == 'months') {
      startDate = moment().startOf('month');
      endDate = moment().endOf('month');
      console.log('startDate',startDate)
      console.log('endDate',endDate)
      this.setState({
        startDate: startDate,
        endDate: endDate
      });
    }else{
      startDate = moment().subtract(6, 'days');
      endDate = moment();
      this.setState({
        startDate: startDate,
        endDate: endDate
      });
    }
    const arrangeBy = evt.target.value
    this.setState({ 
      arrangeBy: arrangeBy,
    });
    const {
      actions: { getDashobardData }
    } = this.props;

    isLoading = "true";
    getDashobardData({ graphDateRange: 'dateRange',limit:this.state.limit, startDate:startDate.format("YYYY-MM-DD 00:00:00"),  endDate:endDate.format("YYYY-MM-DD 23:59:59"), arrangeBy:arrangeBy, cityID: this.state.cityID });
  }
/*
  onUpdateViewByCity1 = () => evt => {
    const arrangeByCity = evt.target.value
    console.log('arrangeByCity',arrangeByCity)
    this.setState({ 
      cityID: arrangeByCity,
    });
    const {
      actions: { getDashobardData }
    } = this.props;

    isLoading = "true";
    getDashobardData({ cityID:arrangeByCity });
  } */

  onUpdateViewByCity = (e) => {
    let arrangeByCity = e.target.value;
    this.setState({ 
      cityID: arrangeByCity,
    });
    const {
      actions: { getDashobardData }
    } = this.props;
    this.setState({[e.target.name] : e.target.value})
    isLoading = "true";
    getDashobardData({ graphDateRange: 'dateRange',limit:this.state.limit, startDate:this.state.startDate.format("YYYY-MM-DD 00:00:00"),  endDate:this.state.endDate.format("YYYY-MM-DD 23:59:59"), arrangeBy:this.state.arrangeBy, cityID:arrangeByCity });
  }

  addSymbols(e){
    var suffixes = ["", "K", "M", "B"];
    var order = Math.max(Math.floor(Math.log(e.value) / Math.log(1000)), 0);
    if(order > suffixes.length - 1)
      order = suffixes.length - 1;
    var suffix = suffixes[order];
    return CanvasJS.formatNumber(e.value / Math.pow(1000, order)) + suffix;
  }

  render() {
    console.log("rendering..")
    
    const { dashboardData } = this.state;
    if(dashboardData.graphRecord){
      BarData = dashboardData.graphRecord;
    }
    else
    {
      BarData = [];
    }
    BarData = BarData.map(function (x, y) { 
      if(x.values) {
        let xx = x.label;
        let xy = x.values.map(function(a, b) {
          let ab=a.x; let bb=parseFloat(a.y, 10);
          return {x:ab, y:bb};
        });
        return {label:xx, values:xy}
      }
    });  
    let start = this.state.startDate.format('MMMM D, YYYY');
    let end = this.state.endDate.format('MMMM D, YYYY');
    let label = start + ' - ' + end;
    if (start === end) {
      label = start;
    }
    let buttonStyle = { width: '100%' };

    let contentOfferRow, contentCityRow;
    if (!isEmpty(dashboardData.topOffers)) {
      contentOfferRow = dashboardData.topOffers.map((val, index) => (
        <tr key={'topOffers'+index}>
          <td>{ReactHtmlParser(val.mainDealText)}</td>
          <td>{val.merchantName}</td>
          <td>{val.amount}</td>
        </tr>
      ));
    } 
    if (!isEmpty(dashboardData.topSellingCities)) {
      contentCityRow = dashboardData.topSellingCities.map((val, index) => (
        <tr key={'citySales'+index}>
          <td>{val.title}</td>
          <td>{val.amount}</td>
        </tr>
      ));
    }
    salesAmt = parseFloat(dashboardData.total_sale_amount);
    
    return (
      <AnimatedView>
        <div>
        <div className="panel">
          <header className="panel-heading">Todays Transactions</header>
          </div>
          <div className="row" style={{ marginBottom: "5px" }}>

            <div className="col-md-3">
              <StatsCard
                statValue={"" + this.toDollars(salesAmt)}
                statLabel={"Total Sales"}
                icon={<i className="glyphicon glyphicon-usd" />}
                backColor={"green"}
              />
            </div>
            <div className="col-md-3">
              <StatsCard
                statValue={"" + ((dashboardData.total_transactions) ? dashboardData.total_transactions : '0')}
                statLabel={"Total Transactions"}
                icon={<i className="glyphicon glyphicon-transfer" />}
                backColor={"violet"}
              />
            </div>
            <div className="col-md-3">
              <StatsCard
                statValue={"" + ((dashboardData.total_users) ? dashboardData.total_users : '0')}
                statLabel={"Total Users"}
                icon={<i className="glyphicon glyphicon-user" />}
                backColor={"red"}
              />
            </div>
            <div className="col-md-3">
              <StatsCard
                statValue={"" + ((dashboardData.voucher_sold) ? dashboardData.voucher_sold : '0')}
                statLabel={"Total Voucher Sold"}
                icon={<i className="glyphicon glyphicon-sound-dolby" />}
                backColor={"blue"}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="panel">
                <div className="row">
                  <div className="col-md-4">
                    <header className="panel-heading">Transactions</header>
                  </div>
                  <div className="col-md-4">
                    <FormGroup>
                      <FormControl componentClass="select" value={this.state.arrangeByCity} placeholder="select" name="arrangeByCity" onChange={this.onUpdateViewByCity}>
                          <option value="">Choose Region/City</option>
                        {(this.state.cityList) &&
                          this.state.cityList.map((data, index) =>
                            <optgroup key={'hcity'+index} label={data.country}>
                              {(data.cities) &&
                                data.cities.map((city, index) => 
                                  <option key={'hcityval'+index} value={city.cityID}>{city.title}</option>
                                )
                              }
                            </optgroup>
                          )
                        }
                      </FormControl>
                  </FormGroup>
                  </div>
                  <div className="col-md-4">
                    <div className="row"  style={{ marginBottom: "10px" }}>
                      <div className="col-md-12">
                        <select
                          name="arrangeBy"
                          className="form-control"
                          value={this.state.arrangeBy}
                          onChange={this.onUpdateView()}
                        >
                          <option key="days" value="days">
                            View by Days
                          </option>
                          <option key="months" value="months">
                            View by Months
                          </option>
                        </select>
                      </div>
                    </div>
                       
                    <div className="row">
                      <div className="col-md-12">
                        <DatetimeRangePicker
                          startDate={this.state.startDate}
                          endDate={this.state.endDate}
                          ranges={this.state.rangesByMonth}
                          onApply={this.handleDateEvent}
                        >
                        
                          <Button className="selected-date-range-btn" style={{display: (this.state.arrangeBy == 'months') ? 'block' : 'none' }}>
                            <div className="pull-left">
                              <i className="glyphicon glyphicon-calendar"/>
                              &nbsp;
                              <span>
                                {label}
                              </span>
                            </div>
                            <div className="pull-right">
                              <i className="fa fa-angle-down"/>
                            </div>
                          </Button>
                        </DatetimeRangePicker>
                      </div>
                    </div>
                   
                   <div className="row">
                      <div className="col-md-12">
                        <DatetimeRangePicker
                          startDate={this.state.startDate}
                          endDate={this.state.endDate}
                          ranges={this.state.ranges}
                          onApply={this.handleDateEvent}
                        >
                        
                          <Button className="selected-date-range-btn" style={{display: (this.state.arrangeBy == 'days') ? 'block' : 'none' }}>
                            <div className="pull-left">
                              <i className="glyphicon glyphicon-calendar"/>
                              &nbsp;
                              <span>
                                {label}
                              </span>
                            </div>
                            <div className="pull-right">
                              <i className="fa fa-angle-down"/>
                            </div>
                          </Button>
                        </DatetimeRangePicker>
                      </div>
                    </div>                    
                  
                  </div>
                </div>
                {isLoading == "true" ? (
                  <div className="loader">
                    <p className="loading-message">
                      <i>Loading...</i>
                    </p>
                    <div className="spinner">
                      <div className="dot1" />
                      <div className="dot2" />
                    </div>
                  </div>
                ) : (
                  ""
                )} 
                <div className="panel-body">
                  {BarData.length > 0 ? (
                  <BarChart
                    groupedBars
                    data={BarData}
                    xAxis={{tickDirection : "diagonal"}} 
                    tooltipHtml={this.tooltipBar}
                    width={900} 
                    height={400}
                    style={{width: '100%'}} 
                    margin={{ top: 10, bottom: 80, left: 50, right: 10 }}
                  />) : ("No Data Found ...")}
                </div>
              </div>
              {/*<WorkProgress />*/}
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="panel">
                <header className="panel-heading">Top Selling Offers</header>
                <div className="panel-body">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Offer</th>
                        <th>Merchant</th>
                        <th>Sales</th>
                      </tr>
                    </thead>
                    <tbody>{contentOfferRow}</tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="panel">
                <header className="panel-heading">Top Selling Cities</header>
                <div className="panel-body">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>City</th>
                        <th>Sales</th>
                      </tr>
                    </thead>
                    <tbody>{contentCityRow}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AnimatedView>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.siteReducer.loading,
    error: state.siteReducer.error,
    dashboardData: state.siteReducer.dashboardData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...siteActions
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/app/views/admin/dashboard/Dashboard.js